// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__20xD_","actions":"Section_actions__3fjNP","count":"Section_count__2xlTJ","name":"Section_name__lkt1z"};